(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eatalo-bundle-product"]) return;
  try {
    
  (function () {
    function initBundlePage(root) {
      if (root.dataset.ebpReady) return;
      root.dataset.ebpReady = '1';
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('.ebp__thumb'));
      var slides = Array.prototype.slice.call(root.querySelectorAll('.ebp__slide'));
      if (!thumbs.length) return;

      function show(target) {
        slides.forEach(function (sl) {
          sl.classList.toggle('is-active', sl.dataset.slide === target);
        });
        thumbs.forEach(function (th) {
          var on = th.dataset.target === target;
          th.classList.toggle('is-active', on);
          th.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on && th.scrollIntoView) {
            th.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        });
      }

      thumbs.forEach(function (th, i) {
        th.addEventListener('click', function () {
          show(th.dataset.target);
        });
        th.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = thumbs[(i + 1) % thumbs.length];
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = thumbs[(i - 1 + thumbs.length) % thumbs.length];
          if (next) {
            e.preventDefault();
            next.focus();
            show(next.dataset.target);
          }
        });
      });

      /* Swipe on the main picture (phone) */
      var stage = root.querySelector('.ebp__stage');
      var startX = null;
      stage.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        var current = thumbs.findIndex(function (th) { return th.classList.contains('is-active'); });
        var next = dx < 0 ? current + 1 : current - 1;
        if (next < 0 || next >= thumbs.length) return;
        show(thumbs[next].dataset.target);
      }, { passive: true });
    }

    function initAll() {
      document.querySelectorAll('.ebp').forEach(initBundlePage);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    /* The theme editor re-renders the section after every setting change */
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
